import { render, staticRenderFns } from "./CheckoutDelivery.vue?vue&type=template&id=831a29c2&scoped=true"
import script from "./CheckoutDelivery.vue?vue&type=script&lang=js"
export * from "./CheckoutDelivery.vue?vue&type=script&lang=js"
import style0 from "./CheckoutDelivery.vue?vue&type=style&index=0&id=831a29c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831a29c2",
  null
  
)

export default component.exports